(function ( $ ) {
    $.fn.stuckNav = function() {
        var $that = $(this),
        	h = $that.outerHeight(),
        	top = $that.offset().top;
        
        return $window.on('scroll', function(e){
        	e.preventDefault();

        	if ((top < wt + hh)) {
        		$that.addClass('is-stuck');
                $body.addClass('section-nav-stuck');
        		$that.css('height', h);
        	} else {
        		$that.removeClass('is-stuck');
                $body.removeClass('section-nav-stuck');
        	}
        })
    };
}( jQuery ));

$(function(){
    if ($('.js-section-nav').length) {
        $('.js-section-nav').stuckNav();
    }
});